import React from 'react';

function SecurityPanel({ userProfile, setModalType, setIdChangeStep, myReports, setSelectedTrackingCase }) {
  const activeReport = myReports.find(r => r.status === 'open');

  return (
    <div className="security-section animate-up">
      <div className="glass-card" style={{padding: '40px'}}>
        <h2 style={{fontSize: '2rem', fontWeight: '800', marginBottom: '10px', letterSpacing: '-1px'}}>Security & Sovereignty</h2>
        <p style={{color: 'var(--text-secondary)', marginBottom: '40px', fontSize: '1.1rem'}}>Managed through cryptographically secured Origin Core protocols.</p>
        
        <div className="id-card-list">
          <div className="id-card">
            <div>
              <label className="theme-label">Public Identity (PID)</label>
              <div style={{fontSize: '1.4rem', color: 'var(--text-primary)', fontWeight: '900', marginTop: '5px'}}>{userProfile.profileId}</div>
            </div>
            <button 
              onClick={() => { setModalType('idchange'); setIdChangeStep(1); }}
              className="btn btn-secondary" 
              style={{marginTop: '20px', padding: '8px 15px', fontSize: '0.8rem', width: '100%'}}
            >
              <i className="fa-solid fa-shuffle"></i> Request Migration
            </button>
          </div>

          <div className="id-card">
            <label className="theme-label">Support Secret (SUID)</label>
            <div style={{fontSize: '1.4rem', color: 'var(--brand-accent)', marginTop: '5px', fontWeight: '900'}}>{userProfile.suid || "PENDING"}</div>
            <p style={{fontSize: '0.7rem', color: 'var(--text-secondary)', marginTop: '15px'}}>Confidential key for administrative handshake.</p>
          </div>

          <div className="id-card">
            <label className="theme-label">Embed Token (EID)</label>
            <div style={{fontSize: '1.4rem', color: 'var(--text-primary)', marginTop: '5px', fontWeight: '900'}}>{userProfile.eid || "UNSET"}</div>
            <p style={{fontSize: '0.7rem', color: 'var(--text-secondary)', marginTop: '15px'}}>Identifier for multi-environment synthesis.</p>
          </div>
        </div>

        <div className="governance-tracking" style={{marginTop: '50px', borderTop: '1px solid var(--glass-border)', paddingTop: '50px'}}>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '35px', flexWrap: 'wrap', gap: '20px'}}>
            <div>
              <h3 style={{fontSize: '1.6rem', fontWeight: '800', color: '#fff', marginBottom: '8px'}}>Governance & Oversight</h3>
              <p style={{color: 'var(--text-secondary)', margin: 0, fontSize: '0.95rem'}}>Oversight of security audits, identity migrations, and platform parity.</p>
            </div>
            <button className="btn btn-primary" onClick={() => setModalType('report')} style={{height: '50px', padding: '0 30px'}}>
              <i className="fa-solid fa-file-shield"></i> Submit Compliance Case
            </button>
          </div>
          
          {activeReport && (
            <div className="active-case-banner glass-card" style={{background: 'rgba(0, 255, 140, 0.05)', border: '1px solid var(--brand-accent)', padding: '25px', borderRadius: '20px', marginBottom: '35px', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
              <div style={{display: 'flex', alignItems: 'center', gap: '25px'}}>
                <div className="pulse-icon pulse" style={{width: '15px', height: '15px', background: 'var(--brand-accent)', borderRadius: '50%', boxShadow: '0 0 15px var(--brand-accent)'}}></div>
                <div>
                  <strong style={{display: 'block', color: '#fff', fontSize: '1.1rem'}}>Neural Audit in Progress</strong>
                  <span style={{fontSize: '0.9rem', color: 'var(--brand-accent)', fontWeight: '700'}}>{activeReport.reportId} — {activeReport.subject}</span>
                </div>
              </div>
              <div style={{textAlign: 'right'}}>
                <span style={{fontSize: '0.75rem', color: '#8b949e', display: 'block', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: '5px'}}>Resolution ETA</span>
                <strong style={{color: '#fff', fontSize: '1.1rem'}}>~36 Standard Hours</strong>
              </div>
            </div>
          )}

          <div className="reports-table-container" style={{background: 'rgba(255,255,255,0.02)', padding: '20px', borderRadius: '24px', border: '1px solid var(--glass-border)', marginTop: '20px'}}>
             <table className="reports-table" style={{width: '100%', borderCollapse: 'collapse', textAlign: 'left'}}>
               <thead>
                 <tr style={{borderBottom: '1px solid var(--glass-border)'}}>
                   <th style={{padding: '15px 10px', color: 'var(--text-secondary)', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '1px'}}>Identifier</th>
                   <th style={{padding: '15px 10px', color: 'var(--text-secondary)', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '1px'}}>Subject</th>
                   <th style={{padding: '15px 10px', color: 'var(--text-secondary)', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '1px'}}>Status</th>
                   <th style={{padding: '15px 10px', color: 'var(--text-secondary)', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '1px'}}>Last Activity</th>
                 </tr>
               </thead>
               <tbody>
                 {myReports.length > 0 ? myReports.map(report => {
                   const isOpen = report.status === 'open';
                   const isResolved = report.status === 'resolved' || report.status === 'completed';
                   const isRejected = report.status === 'rejected';

                   return (
                     <tr 
                       key={report.reportId} 
                       style={{borderBottom: '1px solid rgba(255,255,255,0.03)', cursor: 'pointer'}}
                       onClick={() => setSelectedTrackingCase(report)}
                       className="tracking-row-hover"
                     >
                       <td style={{padding: '20px 10px'}}>
                         <span style={{fontFamily: 'monospace', color: 'var(--brand-accent)', fontWeight: 'bold'}}>{report.reportId}</span>
                       </td>
                       <td style={{padding: '20px 10px'}}>
                         <span style={{color: '#fff', fontWeight: '500'}}>{report.subject}</span>
                       </td>
                       <td style={{padding: '20px 10px'}}>
                         <span style={{
                           fontSize: '0.7rem', 
                           padding: '4px 12px', 
                           borderRadius: '50px',
                           fontWeight: 'bold',
                           background: isOpen ? 'rgba(0, 255, 140, 0.1)' : isResolved ? 'rgba(22, 163, 74, 0.1)' : 'rgba(239, 68, 68, 0.1)',
                           color: isOpen ? 'var(--brand-accent)' : isResolved ? '#16A34A' : '#EF4444',
                           border: `1px solid ${isOpen ? 'rgba(0, 255, 140, 0.2)' : isResolved ? 'rgba(22, 163, 74, 0.2)' : 'rgba(239, 68, 68, 0.2)'}`
                         }}>
                           {report.status.toUpperCase()}
                         </span>
                       </td>
                       <td style={{padding: '20px 10px', color: '#8b949e', fontSize: '0.85rem'}}>
                         {new Date(report.updatedAt || report.createdAt).toLocaleDateString()}
                       </td>
                     </tr>
                   );
                 }) : (
                   <tr>
                     <td colSpan="4" style={{padding: '40px', textAlign: 'center', color: 'var(--text-secondary)'}}>No historical reports found.</td>
                   </tr>
                 )}
               </tbody>
             </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SecurityPanel;
